// 在 main.js 最顶部添加
window.WebSocket = function (...args) {
    // 打印连接信息，帮助定位来源
    console.log('有人尝试创建WebSocket连接:', args[0]);
    // 阻止连接建立
    return {
        close: () => { }, // 空实现避免报错
        send: () => { }
    };
};
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import { createApp } from 'vue';
import App from './App.vue';
// 导入路由配置（需自行创建路由文件）
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'; // 引入中文语言包
import router from "./router";
import '@/assets/styles/theme.css';
// 2. Vue 3.x 项目全局注册（使用createApp）
const app = createApp(App)


// 注册所有Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(ElementPlus, {
    locale: zhCn, // 配置中文语言
})
app.use(router)
app.mount('#app')